import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/pelletizing/QualityPlan";
import {
    newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.QualityPlan(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    }) //TODO load at the application start
    .withActions({

        Write(context, entity) {
            context.dispatch("qualitySamplePlan/qualityPlanStatus", entity, {
                root: true
            });
            router.push({
                path: '/prd/qualitySamplePlan',
                query: {
                    id: entity.id
                }
            });
        },

        Logging(context, entity) {
            context.dispatch("qualityData/qualityPlanStatus", entity, {
                root: true
            });
            router.push({
                path: '/prd/qualityData',
                query: {
                    id: entity.id
                }
            });

        },
        Result() {
            router.push('/prd/qualityResult');
        },
        ReadQualityPlan(context) {

            context.dispatch("api/get", {
                    url: context.state.baseModuleUrl + "/qualityPlan" + "/readQualityPlan/"
                }, {
                    root: true
                })
                .then(response => {

                    {

                        context.commit('qualityPlan' + "/setRows", response, {
                            root: true
                        });
                    }
                });

        }
    })
    .buildStore()